



























































































































































































































































































































































































































































































































































































































import {
  Vue, Component, Mixins, Watch, Prop,
} from 'vue-property-decorator';
import MyList from '@/mixins/list';
import _ from 'lodash';
import moment from 'moment';
import AreaPicker from '@/components/areapicker.vue';
import SelectCustomer from '@/components/selectcustomer.vue';

import { isAI, isCooperate, isTelBooking } from '@/libs/utils';
import Audit from '@/views/enterapply/audit.vue';
import SyslogManage from '@/views/syslog/manage.vue';
import SyslogEnterapply from '@/views/syslog/action.vue';
import Price from './price.vue';
import EquipmentControl from './equipment_control.vue';
import Equipment from './equipment.vue';
import Add from './add.vue';
import Modal from './modal.vue';
import Settlement from './settlement.vue';
import Ground from './ground.vue';
import Product from './product.vue';
import Online from './online.vue';
import ManageRecord from './manage_record.vue';
import Member from './member.vue';
import User from './user.vue';
import Account from './account.vue';
import Role from './role.vue';
import InviteLog from '../invitecode/logs.vue';
import Similar from './similar.vue';
import Edit from './edit.vue';

import GroundCalendar from './ground_calendar.vue';

@Component({
  components: {
    AreaPicker,
    Add,
    Modal,
    Price,
    EquipmentControl,
    Equipment,
    Settlement,
    Ground,
    Product,
    Online,
    ManageRecord,
    Member,
    User,
    Account,
    Role,
    InviteLog,
    Similar,
    SelectCustomer,
    Edit,
    Audit,
    GroundCalendar,
    SyslogManage,
    SyslogEnterapply,
  },
})
export default class extends Mixins(MyList) {
  @Prop() stype!: any;

  dispatchType = 'stadium/getStadiums';

  priceModalVisible = false;

  controlModalVisible = false;

  equipModalVisible = false;

  settlementModalVisible = false;

  groundModalVisible = false;

  productModalVisible = false;

  onlineModalVisible = false;

  managerecordModalVisible = false;

  memberModalVisible = false;

  userModalVisible = false;

  accountModalVisible = false;

  bookingblockModalVisible = false;

  roleModalVisible = false;

  invitelogModalVisible = false;

  similarModalVisible = false;

  newEditModalVisible = false;

  auditModalVisible = false;

  syslogManageModalVisible = false;

  syslogEnterapplyModalVisible = false;

  calendarModalVisible = false;

  stadiumId!: number;

  fromStadiumId = 0;

  customerId = 0;

  applyId = 0;

  stadium: any = {};

  isAI: (...args: any[]) => any = isAI;

  isCooperate: (...args: any[]) => any = isCooperate;

  isTelBooking: (...args: any[]) => any = isTelBooking;

  // sType = "";
  columns: any[] = [];

  columns1: any[] = [
    {
      title: '编号',
      scopedSlots: { customRender: 'index' },
    },
    { title: '城市', dataIndex: 'city_name' },
    { title: '场馆名称', scopedSlots: { customRender: 'name' } },
    { title: '注册时间', dataIndex: 'created_time' },
    { title: '订场电话', dataIndex: 'phone' },
    { title: '场地片数', dataIndex: 'ground_count' },
  ];

  columns2: any[] = [{ title: '场馆主体', dataIndex: 'business_units' }];

  columns3: any[] = [
    { title: '上线状态', scopedSlots: { customRender: 'online_status' } },
    {
      title: '场馆状态',
      width: 100,
      scopedSlots: { customRender: 'stadium_status' },
    },
  ];

  columns4: any[] = [
    { title: '操作', width: 200, scopedSlots: { customRender: 'action' } },
  ];

  
// 操作搜索栏的展开和折叠
  isFlag = false;

  @Watch('$route')
  watchRoute(to: any, from: any) {
    if (!_.isEqual(from, to)) {
      if (to.path !== from.path) {
        this.searchData = {};
      }

      switch (this.stype) {
        case 'manager':
        case 'newly':
        case 'new':
          this.columns = _.concat(this.columns1, this.columns4);
          break;
        case 'pending':
          this.columns = _.concat(this.columns1, this.columns2, this.columns4);
          break;
        case 'active':
        case 'internal':
        case 'database':
        case 'all':
        default:
          this.columns = _.concat(
            this.columns1,
            this.columns2,
            this.columns3,
            this.columns4,
          );
          break;
      }
    }

    // this.stype = to.params.key;
    this.searchData = {};

    this.loadData({
      stype: this.stype,
    });
  }

  showAddStadiumModal(id: number, stadiumId: number) {
    this.customerId = id;
    this.fromStadiumId = stadiumId;
    this.addModalVisible = true;
  }

  hideAddStadiumModal() {
    this.addModalVisible = false;
    this.customerId = 0;
    this.fromStadiumId = 0;
    this.loadData({
      stype: this.stype,
    });
  }

  showAuditModal(id: number) {
    this.stadiumId = id;
    this.auditModalVisible = true;
  }

  hideAuditModal() {
    this.auditModalVisible = false;
  }

  showCalendarModal(id: number) {
    this.stadiumId = id;
    this.calendarModalVisible = true;
  }

  hideCalendarModal() {
    this.calendarModalVisible = false;
  }

  showSyslogManageModal(id: number) {
    // console.log(id);
    this.stadiumId = id;
    this.syslogManageModalVisible = true;
  }

  hideSyslogManageModal() {
    this.syslogManageModalVisible = false;
  }

  showSyslogEnterapplyModal(id: number) {
    this.stadiumId = id;
    this.syslogEnterapplyModalVisible = true;
  }

  hideSyslogEnterapplyModal() {
    this.syslogEnterapplyModalVisible = false;
  }

  changeArea(val: any, selectedOptions: any) {
    if (val.length > 1) {
      this.searchData.province_id = val[0];
      this.searchData.city_id = val[1];
    } else if (val.length > 0) {
      this.searchData.province_id = val[0];
    }
  }

  mounted() {
    switch (this.stype) {
      case 'manager':
      case 'newly':
      case 'new':
        this.columns = _.concat(this.columns1, this.columns4);
        break;
      case 'pending':
        this.columns = _.concat(this.columns1, this.columns2, this.columns4);
        break;
      case 'active':
      case 'internal':
      case 'database':
      case 'all':
      default:
        this.columns = _.concat(
          this.columns1,
          this.columns2,
          this.columns3,
          this.columns4,
        );
        break;
    }
    this.loadData({
      stype: this.stype,
    });
  }

  showEquipModal(id: number) {
    this.stadiumId = Number(id);
    this.equipModalVisible = true;
  }

  hideEquipModal() {
    this.equipModalVisible = false;
  }

  showPriceModal(id: number) {
    this.stadiumId = id;
    this.priceModalVisible = true;
  }

  hidePriceModal() {
    this.priceModalVisible = false;
  }

  showControlModal(id: number) {
    this.stadiumId = id;
    this.controlModalVisible = true;
  }

  hideControlModal() {
    this.controlModalVisible = false;
  }

  showSettlementModal(id: number) {
    this.stadiumId = id;
    this.settlementModalVisible = true;
  }

  hideSettlementModal() {
    this.settlementModalVisible = false;
  }

  showGroundModal(id: number) {
    this.stadiumId = id;
    this.groundModalVisible = true;
  }

  hideGroundModal() {
    this.groundModalVisible = false;
  }

  showProductModal(id: number) {
    this.stadiumId = id;
    this.productModalVisible = true;
  }

  hideProductModal() {
    this.productModalVisible = false;
  }

  showOnlineModal(id: number) {
    this.applyId = id;
    this.onlineModalVisible = true;
  }

  hideOnlineModal() {
    this.onlineModalVisible = false;
  }

  showManageRecordModal(id: number) {
    this.stadiumId = id;
    this.managerecordModalVisible = true;
  }

  hideManageRecordModal() {
    this.managerecordModalVisible = false;
  }

  showBookingBlockModal(id: number) {
    this.stadiumId = id;
    this.bookingblockModalVisible = true;
  }

  hideBookingBlockModal() {
    this.bookingblockModalVisible = false;
  }

  showMemberModal(id: number) {
    this.stadiumId = id;
    this.memberModalVisible = true;
  }

  hideMemberModal() {
    this.memberModalVisible = false;
  }

  showUserModal(id: number) {
    this.stadiumId = id;
    this.userModalVisible = true;
  }

  hideUserModal() {
    this.userModalVisible = false;
  }

  showAccountModal(id: number) {
    this.stadiumId = id;
    this.accountModalVisible = true;
  }

  hideAccountModal() {
    this.accountModalVisible = false;
  }

  showRoleModal(id: number) {
    this.stadiumId = id;
    this.roleModalVisible = true;
  }

  hideRoleModal() {
    this.roleModalVisible = false;
  }

  showInvitelogModal(id: number, applyId: number) {
    this.stadiumId = id;
    this.applyId = applyId;
    this.invitelogModalVisible = true;
  }

  hideInvitelogModal() {
    this.invitelogModalVisible = false;
  }

  showSimilarModal(stadium: any) {
    // console.log(stadium)
    this.stadium = stadium;
    this.similarModalVisible = true;
  }

  hideSimilarModal() {
    this.similarModalVisible = false;
  }

  showNewEditModal(stadiumId: number) {
    this.editId = stadiumId;
    this.newEditModalVisible = true;
  }

  hideNewEditModal() {
    this.newEditModalVisible = false;
    this.loadData({ stype: this.stype });
  }

  async setStadiumStatus(val: any, id: number) {
    this.$confirm({
      title: '确认信息',
      content: `您确定要${val === false ? '下线' : '上线'}该场馆吗？`,
      onOk: async () => {
        if (!this.checkPermission('admin-stadium-stadium-status')) {
          this.$message.warning('没有权限');
          return;
        }
        const res = await this.$store.dispatch('stadium/stadiumstatus', {
          id,
          val,
        });
        // console.log(res)
        if (res && res.Message && res.Message === 'success') {
          this.$message.success('操作成功');
          this.loadData({
            stype: this.stype,
          });
        } else {
          this.$message.error('操作失败');
        }
      },
    });
  }

  async sendInviteCode(stadiumId: number) {
    this.$confirm({
      title: '确认信息',
      content: '您确定要给这家场馆发送邀请码吗？',
      onOk: async () => {
        const res = await this.$store.dispatch('stadium/sendinvitecode', {
          stadium_id: stadiumId,
        });
        if (res && res.Message && res.Message === 'success') {
          this.$message.success('操作成功');
        } else {
          this.$message.error(res.Message);
        }
      },
    });
  }

  copyDemoData(id: number) {
    this.$confirm({
      title: '确认消息',
      content: '你确定拷贝最近2个月演示场馆的数据到该场馆吗？',
      onOk: async () => {
        const res = await this.$store.dispatch('stadium/copyDemoData', {
          stadium_id: id,
        });
        if (res && res.Message && res.Message === 'success') {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      },
    });
  }

  copyDayDemoData(id: number) {
    this.$confirm({
      title: '确认消息',
      content: '你确定拷贝当天演示场馆的数据到该场馆吗？',
      onOk: async () => {
        const res = await this.$store.dispatch('stadium/copyDemoData', {
          stadium_id: id,
          t: 'day',
        });
        if (res && res.Message && res.Message === 'success') {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      },
    });
  }

  deleteDemoData(id: number) {
    this.$confirm({
      title: '确认消息',
      content: '你确定要删除该场馆的演示数据吗？',
      onOk: async () => {
        const res = await this.$store.dispatch('stadium/deleteDemoData', {
          stadium_id: id,
        });
        if (res && res.Message && res.Message === 'success') {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      },
    });
  }
}
